import { data } from "autoprefixer"
import { del, get, post, put } from "./api_helper"
import { del2,get2,post2,put2 } from "./api_helper2"

//admin
export const getadmin=(id)=>get(`auth/${id}`)
export const createAdmin=(data)=>post('auth/signup/admin',data)

export const getAllUsers = ()=> get("/users")
export const getUserById =(id)=>get(`users/${id}`)
export const getallAdmins =()=>get('users/admins/all')



//proprety
export const createProprety =(data)=> post("/properties",data)
export const getProperties  =()=> get("/properties")
export const getcounte =()=>get('/properties/count/prop')
export const getPropById = (id)=>get(`/properties/${id}`)
export const enableprop0 =(id)=>put(`/properties/enable/prop/${id}`)
export const disableprop0 =(id)=>put(`/properties/disable/prop/${id}`)
export const delPropById = (id)=>del(`/properties/${id}`)

export const updateowner = (id,newOwner)=>put(`/properties/${id}/change-owner`,{newOwner:newOwner})
export const updatepassword = (id,newPassword)=>put(`/properties/${id}/change-password`,{newPassword:newPassword})


///////////
export const countpayement = ()=>get('payments/statsp/count')
export const counthotelreservation= ()=>get('hotelreservations/stats/count')
export const countvoyage=()=>get('reservations/statsr/count')

export const notifsend=(id)=>put(`hotelreservations/notif/${id}`)


export const visamonthly=()=>get('visas/statsv/monthly')
export const hotelreservationmonthly= ()=>get('hotelreservations/stats/monthly')
export const voyagemonthly=()=>get('reservations/statsr/monthly')
//places
export const getAllPlaces = ()=>get("/places")

//users
export const changeavailable = (id)=>put(`/users/state/${id}`)

export const loginreq = (values) => post("/auth/login/admin",values)
export const registerreq = (values)=> post("/auth/signup/admin",values)
export const updateprofilereq = (values,id)=>put(`/users/${id}`,values)
export const getuserinfo = (id)=>get(`/users/${id}`)
export const getcounte2 =()=>get('/users/count/prop')

export const delAdmin =(id)=>del(`/users/admin/${id}`)

//visa
export const getAllvisas =()=>get('/visas')
export const getVisa =(id)=>get(`/visas/${id}`)
export const putVisa =(id)=>put(`/visas/user/paid/${id}`)
export const accetpVisa = (id,data)=>put(`/visas/accept/${id}`,data)
export const refuseVisa = (id,data )=>put(`/visas/refuse/${id}`,data)

export const getcounte3 =()=>get('/visas/count/prop')
export const delVisa =(id)=>del(`/visas/${id}`)

//Support-ticket
export const getAllTicket = ()=> get("/support-tickets")

export const deleteTicket = (id)=> del(`/support-tickets/${id}`)
export const getTicketById = (id)=>get(`/support-tickets/${id}`)

export const getAllMessagesForTicket = (ticketId) =>
    get(`/support-tickets/${ticketId}/messages`); // Fetch all messages for a ticket
  export const sendMessageInTicket = (ticketId, data) =>
    post(`/support-tickets/message/${ticketId}`, data); // Send a new message in a ticket
  
  // Admin-specific actions
  export const answerTicket = (id, data) =>
    put(`/support-tickets/answer/${id}`, data); // Answer a ticket (admin only)
  export const closeTicket = (id) => put(`/support-tickets/close/${id}`); // Close a ticket (admin only)
  export const reopenTicket = (id) => put(`/support-tickets/reopen/${id}`); // Reopen a ticket (admin only)
  export const assignAdmin =(id,data)=>put(`/support-tickets/assign/${id}`,{adminUsername:data})

  // User-specific actions
  export const getUserTickets = (userId) =>
    get(`/support-tickets/user/${userId}`); // Fetch all tickets for a specific user
  export const createUserTicket = (userId, data) =>
    post(`/support-tickets/user/${userId}`, data); // Create a ticket for a specific user
  //-------------------------------------


export const userdatanew = ()=>get('auth/userdata')

export const getuseronpage=(pageNumber)=>post('users/list',pageNumber)
export const userfakedelete = (id)=>put(`users/fake/delete/${id}`)
export const userdelete = (id)=>del(`users/${id}`)
//place
export const createplace =(data)=>post('places',data)
export const getplaces = ()=> get('places')

//payement
export const getAllPayments=()=>get('payments')
export const getmonthly=()=>get('payments/pay/monthly-earnings')
export const getPayement=(id)=>get(`payments/${id}`)
export const createPayement=(data)=>post(`payments`,data)
export const delPayement=(id)=>del(`payments/${id}`)
//reservation
export const getAllreservation =()=>get('reservations')

export const getReservation=(id)=>get(`reservations/${id}`)
export const putReservation=(id)=>put(`reservations/user/paid/${id}`)
export const delReservation=(id)=>del(`reservations/${id}`)

//Hote reservation
export const getallhotelreservation =()=>get('hotelreservations')
export const gethotelreservation =(id)=>get(`hotelreservations/${id}`)
export const puthotelreservation =(id,data)=>put(`hotelreservations/user/paid/${id}`,data)

export const paidpaid =(id)=>put(`hotelreservations/res/res/paid/${id}`)



export const delhotelreservation =(id)=>del(`hotelreservations/${id}`)

export const accepthotel =(id,data)=>put(`hotelreservations/accept/${id}`,data)
export const refusehotel =(id,data)=>put(`hotelreservations/refuse/${id}`,data)

export const acceptReservation =(id,data)=>put(`reservations/accept/${id}`,data)
export const refuseReservation =(id,data)=>put(`reservations/refuse/${id}`,data)
//4200 ROUTE

//voyage organize

export const addvoyageorganize = (data)=>post('voyage-organize',data)
export const getallvoyages = ()=>get('voyage-organize')
export const getVoyageData =(id)=>get(`voyage-organize/${id}`,)
export const availabilityAccept = (id)=>put(`voyage-organize/status-available/${id}`)
export const availabilityRefuse = (id)=>put(`voyage-organize/status-unavailable/${id}`)

export const delVoyageData =(id)=>del(`voyage-organize/${id}`)

export const changeStatus = (id)=>put(`places/state/${id}`)
export const delPlace = (id)=>del(`places/${id}`)
//properties
export const createProp =(prop)=> post2("/properties",{id:prop})
export const getAllProp =()=>get2("/properties")
export const enableprop =(id)=>put2(`/properties/enable/prop/${id}`)
export const disableprop =(id)=>put2(`/properties/disable/prop/${id}`)

//detail
export const getalldetail = (id)=>get2(`/ratepricing/hotel/data/${id}`)
